import { createFileRoute } from '@tanstack/react-router';
import ExternalLayout from 'src/routes/_authenticated/dashboard/external/-external-layout';

export const Route = createFileRoute('/_authenticated/dashboard/external/')({
  component: ExternalLayout,
});
